/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedSubjektUpdateRequest } from '../types/PatchedSubjektUpdate';
import type { SubjektUpdateResponse } from '../types/SubjektUpdate';

export type SubjektyPartialUpdateRequest = PatchedSubjektUpdateRequest;
export type SubjektyPartialUpdateResponse = SubjektUpdateResponse;

export type SubjektyPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this subjekt.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/subjekty/{id}/
 *
 * ```yaml
 * operationId: subjekty_partial_update
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/SubjektUpdate'
 *     description: ''
 * ```
 */
export const subjektyPartialUpdateOperation = ({ id, ...rest }: SubjektyPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/subjekty/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/subjekty/{id}/' };
  };

/**
 * PATCH /dmx-server/subjekty/{id}/
 *
 * ```yaml
 * operationId: subjekty_partial_update
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedSubjektUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/SubjektUpdate'
 *     description: ''
 * ```
 */
export const subjektyPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SubjektyPartialUpdateQuery;
  request: PatchedSubjektUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<SubjektUpdateResponse>> => {
  const operation = subjektyPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
